document.addEventListener('DOMContentLoaded', function() {
  console.log('🎯 === PRODUCT PAGE INITIALIZATION ===');
  
  // ============================================
  // ELEMENT REFERENCES
  // ============================================
  
  const productForm = document.getElementById('product-form');
  const mainImage = document.getElementById('main-product-image');
  const mainImageContainer = document.getElementById('main-image-container');
  const thumbnails = document.querySelectorAll('.thumbnail-item');
  const thumbnailsContainer = document.querySelector('.product-thumbnails');
  const prevButton = document.getElementById('prev-image');
  const nextButton = document.getElementById('next-image');
  const zoomButton = document.getElementById('zoom-button');
  const zoomModal = document.getElementById('image-zoom-modal');
  const zoomClose = document.getElementById('zoom-close');
  const zoomedImage = document.getElementById('zoom-image');
  const paginationDots = document.querySelectorAll('.pagination-dot');
  const zoomPrevBtn = document.getElementById('zoom-prev');
  const zoomNextBtn = document.getElementById('zoom-next');
  const thumbnailPrevBtn = document.getElementById('thumbnail-prev');
  const thumbnailNextBtn = document.getElementById('thumbnail-next');
  
  // ============================================
  // VARIABLES
  // ============================================
  
  let currentImageIndex = 0;
  const productData = window.productJSON;
  let currentVariant = null;
  let touchStartX = 0;
  let touchEndX = 0;
  let touchStartY = 0;
  let touchEndY = 0;
  let isSwiping = false;
  let scrollPosition = 0;
  
  console.log('📦 Product Data:', productData);
  console.log('🆔 Initial Variant ID:', window.currentVariantId);
  
  // ============================================
  // VARIANT SELECTION - DAWN THEME COMPATIBLE
  // ============================================
  
  if (productData && productData.variants && window.currentVariantId) {
    currentVariant = productData.variants.find(v => v.id == window.currentVariantId);
    console.log('✅ Initial variant loaded:', currentVariant ? currentVariant.title : 'Not found');
  }
  
  const variantInputs = productForm ? productForm.querySelectorAll('input[type="radio"]') : [];
  console.log('🔘 Found', variantInputs.length, 'variant selectors');
  
  variantInputs.forEach(input => {
    input.addEventListener('change', handleVariantChange);
  });
  
  function handleVariantChange(e) {
    console.log('🔄 === VARIANT CHANGED ===');
    console.log('Option:', e.target.name, '=', e.target.value);
    
    const selectedValues = [];
    variantInputs.forEach(input => {
      if (input.checked) {
        selectedValues.push(input.value);
        console.log('✅ Selected:', input.value);
      }
    });
    
    const matchingVariant = productData.variants.find(variant => {
      const matches = selectedValues.every(value => 
        variant.options.some(option => option.toLowerCase() === value.toLowerCase())
      );
      return matches && variant.options.length === selectedValues.length;
    });
    
    if (matchingVariant) {
      console.log('✅ MATCHED VARIANT:', matchingVariant.id, '-', matchingVariant.title);
      currentVariant = matchingVariant;
      updateProductDisplay(matchingVariant);
    } else {
      console.error('❌ No variant found for:', selectedValues);
    }
  }
  
  function updateProductDisplay(variant) {
    console.log('🎨 === UPDATING UI ===');
    console.log('Variant ID:', variant.id);
    console.log('Available:', variant.available);
    
    const priceEl = document.getElementById('variant-price');
    const comparePriceEl = document.getElementById('variant-compare-price');
    
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    
    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        comparePriceEl.style.display = 'inline';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }
    
    const skuEl = document.getElementById('variant-sku');
    if (skuEl && variant.sku) {
      skuEl.textContent = variant.sku;
    }
    
    const hiddenInput = document.getElementById('variant-id');
    
    if (hiddenInput) {
      hiddenInput.value = variant.id;
      console.log('✅✅✅ Hidden input set to:', variant.id);
    } else {
      console.error('❌❌❌ Hidden input NOT FOUND');
    }
    
    const addBtn = document.getElementById('add-to-cart-btn');
    
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      addBtn.style.background = '';
      console.log(variant.available ? '✅ Button ENABLED' : '⚠️ Button DISABLED');
    }
    
    variantInputs.forEach(input => {
      if (input.checked) {
        const displayEl = document.getElementById(`selected-${input.name}`);
        if (displayEl) displayEl.textContent = input.value;
      }
    });
    
    const stockEl = document.getElementById('stock-status');
    if (stockEl && variant.inventory_management) {
      if (variant.inventory_quantity > 0 && variant.inventory_quantity <= 10) {
        stockEl.textContent = `Last ${variant.inventory_quantity} left`;
        stockEl.classList.add('low-stock');
        stockEl.style.display = 'block';
      } else if (variant.inventory_quantity > 10) {
        stockEl.textContent = 'In stock';
        stockEl.classList.remove('low-stock');
        stockEl.style.display = 'block';
      } else {
        stockEl.style.display = 'none';
      }
    }
    
    if (window.history.replaceState) {
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
    
    console.log('✅ UI update complete');
  }
  
  if (currentVariant) {
    updateProductDisplay(currentVariant);
  }
  
  // ============================================
  // FORM SUBMISSION - ADD TO CART
  // ============================================
  
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('🛒 === FORM SUBMITTED ===');
      
      const hiddenInput = document.getElementById('variant-id');
      const variantId = hiddenInput ? hiddenInput.value : null;
      
      console.log('📦 Variant ID from form:', variantId);
      
      if (!variantId || variantId === '') {
        console.error('❌ NO VARIANT ID');
        alert('Please select a size/variant before adding to cart.');
        return false;
      }
      
      const addBtn = document.getElementById('add-to-cart-btn');
      const originalText = addBtn ? addBtn.textContent : 'ADD TO CART';
      const originalBg = addBtn ? addBtn.style.background : '';
      
      if (addBtn) {
        addBtn.textContent = 'ADDING...';
        addBtn.disabled = true;
      }
      
      const requestBody = {
        id: variantId,
        quantity: 1
      };
      
      console.log('📤 Sending to Shopify...');
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(requestBody)
      })
      .then(response => {
        console.log('📥 Response:', response.status);
        
        if (!response.ok) {
          return response.json().then(err => {
            throw new Error(err.description || err.message || 'Failed to add to cart');
          });
        }
        
        return response.json();
      })
      .then(data => {
        console.log('✅ SUCCESS:', data);
        
        if (addBtn) {
          addBtn.textContent = 'ADDED ✓';
          addBtn.style.background = '#28a745';
        }
        
        setTimeout(() => {
          window.location.href = '/cart';
        }, 500);
      })
      .catch(error => {
        console.error('❌ ERROR:', error);
        
        if (addBtn) {
          addBtn.textContent = originalText;
          addBtn.disabled = false;
          addBtn.style.background = originalBg;
        }
        
        alert('Error adding to cart. Please try again.');
      });
      
      return false;
    });
    
    console.log('✅ Form submit handler attached');
  }
  
  // ============================================
  // THUMBNAIL NAVIGATION
  // ============================================
  
  if (thumbnailsContainer && thumbnailPrevBtn && thumbnailNextBtn && window.innerWidth >= 750) {
    function updateThumbnailArrows() {
      const scrollLeft = thumbnailsContainer.scrollLeft;
      const maxScroll = thumbnailsContainer.scrollWidth - thumbnailsContainer.clientWidth;
      
      thumbnailPrevBtn.disabled = scrollLeft <= 1;
      thumbnailPrevBtn.style.opacity = scrollLeft <= 1 ? '0.3' : '1';
      
      thumbnailNextBtn.disabled = scrollLeft >= maxScroll - 1;
      thumbnailNextBtn.style.opacity = scrollLeft >= maxScroll - 1 ? '0.3' : '1';
    }
    
    thumbnailPrevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      thumbnailsContainer.scrollBy({ left: -200, behavior: 'smooth' });
      setTimeout(updateThumbnailArrows, 300);
    });
    
    thumbnailNextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      thumbnailsContainer.scrollBy({ left: 200, behavior: 'smooth' });
      setTimeout(updateThumbnailArrows, 300);
    });
    
    thumbnailsContainer.addEventListener('scroll', updateThumbnailArrows);
    setTimeout(updateThumbnailArrows, 500);
  }
  
  // ============================================
  // IMAGE PRELOADING
  // ============================================
  
  function preloadImages() {
    if (productData && productData.media) {
      productData.media.forEach((media) => {
        if (media.preview_image) {
          const img = new Image();
          img.src = media.preview_image.src.replace(/(\.[^.]+)$/, '_600x$1');
        }
      });
    }
  }
  
  preloadImages();
  
  // ============================================
  // THUMBNAIL CLICKS
  // ============================================
  
  thumbnails.forEach((thumb) => {
    thumb.addEventListener('click', function(e) {
      e.preventDefault();
      const newIndex = parseInt(this.getAttribute('data-media-index'));
      if (newIndex !== currentImageIndex) {
        currentImageIndex = newIndex;
        updateMainImage();
        updateActiveThumbnail();
        updatePaginationDots();
      }
    });
  });
  
  // ============================================
  // MAIN IMAGE NAVIGATION
  // ============================================
  
  if (prevButton) {
    prevButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      navigateToPrevious();
    });
  }
  
  if (nextButton) {
    nextButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      navigateToNext();
    });
  }
  
  paginationDots.forEach((dot) => {
    dot.addEventListener('click', function(e) {
      e.preventDefault();
      const newIndex = parseInt(this.getAttribute('data-index'));
      if (newIndex !== currentImageIndex) {
        currentImageIndex = newIndex;
        updateMainImage();
        updatePaginationDots();
      }
    });
  });
  
  // ============================================
  // TOUCH/SWIPE SUPPORT
  // ============================================
  
  if (mainImageContainer) {
    let startTime;
    
    mainImageContainer.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      startTime = Date.now();
      isSwiping = false;
    }, { passive: true });
    
    mainImageContainer.addEventListener('touchmove', (e) => {
      if (!touchStartX || !touchStartY) return;
      
      const diffX = touchStartX - e.touches[0].clientX;
      const diffY = touchStartY - e.touches[0].clientY;
      
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 10) {
        isSwiping = true;
        e.preventDefault();
      }
    }, { passive: false });
    
    mainImageContainer.addEventListener('touchend', (e) => {
      if (!isSwiping) {
        resetTouch();
        return;
      }
      
      const diffX = touchStartX - e.changedTouches[0].clientX;
      const diffTime = Date.now() - startTime;
      
      if (Math.abs(diffX) > 50 && diffTime < 300) {
        if (diffX > 0) {
          navigateToNext();
        } else {
          navigateToPrevious();
        }
      }
      
      resetTouch();
    }, { passive: true });
  }
  
  function resetTouch() {
    touchStartX = 0;
    touchStartY = 0;
    touchEndX = 0;
    touchEndY = 0;
    isSwiping = false;
  }
  
  function navigateToPrevious() {
    if (!productData || !productData.media) return;
    currentImageIndex = (currentImageIndex - 1 + productData.media.length) % productData.media.length;
    updateMainImage();
    updateActiveThumbnail();
    updatePaginationDots();
  }
  
  function navigateToNext() {
    if (!productData || !productData.media) return;
    currentImageIndex = (currentImageIndex + 1) % productData.media.length;
    updateMainImage();
    updateActiveThumbnail();
    updatePaginationDots();
  }
  
  function updateMainImage() {
    if (!mainImage || !productData || !productData.media || !productData.media[currentImageIndex]) return;
    
    const media = productData.media[currentImageIndex];
    if (!media.preview_image) return;
    
    const imageUrl = media.preview_image.src;
    
    mainImage.src = imageUrl.replace(/(\.[^.]+)$/, '_600x$1');
    mainImage.srcset = `
      ${imageUrl.replace(/(\.[^.]+)$/, '_400x$1')} 400w,
      ${imageUrl.replace(/(\.[^.]+)$/, '_600x$1')} 600w,
      ${imageUrl.replace(/(\.[^.]+)$/, '_800x$1')} 800w
    `;
    mainImage.alt = media.alt || productData.title;
    mainImage.dataset.zoomSrc = imageUrl.replace(/(\.[^.]+)$/, '_1500x$1');
  }
  
  function updateActiveThumbnail() {
    thumbnails.forEach((thumb, i) => {
      thumb.classList.toggle('active', i === currentImageIndex);
    });
    
    const activeThumbnail = thumbnails[currentImageIndex];
    if (activeThumbnail) {
      activeThumbnail.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  }
  
  function updatePaginationDots() {
    paginationDots.forEach((dot, i) => {
      dot.classList.toggle('active', i === currentImageIndex);
    });
  }
  
  // ============================================
  // ZOOM MODAL
  // ============================================
  
  if (zoomButton) {
    zoomButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openZoomModal();
    });
  }
  
  if (mainImageContainer) {
    mainImageContainer.addEventListener('click', (e) => {
      if (isSwiping) return;
      if (e.target.closest('.image-zoom-button, .image-nav-arrow, .pagination-dot')) return;
      if (window.innerWidth >= 750) openZoomModal();
    });
  }
  
  function openZoomModal() {
    if (!zoomModal || !zoomedImage || !mainImage) return;
    
    scrollPosition = window.pageYOffset;
    const fullSizeUrl = mainImage.dataset.zoomSrc || mainImage.src.replace(/_\d+x/, '_1500x');
    
    zoomedImage.src = fullSizeUrl;
    zoomedImage.alt = mainImage.alt;
    zoomModal.classList.add('active');
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = '100%';
    document.body.style.left = '0';
    document.body.style.right = '0';
  }
  
  function closeZoomModal() {
    if (!zoomModal) return;
    
    zoomModal.classList.remove('active');
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, scrollPosition);
  }
  
  if (zoomClose) {
    zoomClose.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeZoomModal();
    });
  }
  
  if (zoomModal) {
    zoomModal.addEventListener('click', (e) => {
      if (e.target === zoomModal) closeZoomModal();
    });
    
    if (window.innerWidth < 750) {
      let tapTimeout;
      zoomModal.addEventListener('touchend', (e) => {
        if (e.target.closest('.zoom-nav-arrow, .zoom-close, img')) return;
        
        clearTimeout(tapTimeout);
        tapTimeout = setTimeout(() => {
          closeZoomModal();
        }, 100);
      });
    }
  }
  
  document.addEventListener('keydown', (e) => {
    if (zoomModal && zoomModal.classList.contains('active')) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        closeZoomModal();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        navigateToPrevious();
        updateZoomedImage();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        navigateToNext();
        updateZoomedImage();
      }
    }
  });
  
  if (zoomPrevBtn) {
    zoomPrevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      navigateToPrevious();
      updateZoomedImage();
    });
  }
  
  if (zoomNextBtn) {
    zoomNextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      navigateToNext();
      updateZoomedImage();
    });
  }
  
  function updateZoomedImage() {
    if (zoomedImage && mainImage && mainImage.dataset.zoomSrc) {
      setTimeout(() => {
        zoomedImage.src = mainImage.dataset.zoomSrc;
        zoomedImage.alt = mainImage.alt;
      }, 50);
    }
  }
  
  if (zoomModal) {
    zoomModal.addEventListener('touchmove', (e) => {
      if (e.target === zoomModal) {
        e.preventDefault();
      }
    }, { passive: false });
  }
  
  // ============================================
  // UTILITY FUNCTIONS
  // ============================================
  
  function formatMoney(cents) {
    const amount = cents / 100;
    return 'Rs. ' + amount.toFixed(2).replace(/\.00$/, '');
  }
  
  if (mainImage && productData && productData.media && productData.media.length > 0) {
    const firstMedia = productData.media[0];
    if (firstMedia.preview_image) {
      mainImage.dataset.zoomSrc = firstMedia.preview_image.src.replace(/(\.[^.]+)$/, '_1500x$1');
    }
  }
  
  console.log('✅ === ALL SYSTEMS READY ===');
});